define("settings/routes/groups/group/edit", ["exports", "@ember/object", "@ember/routing/route", "@ember/service", "ember-concurrency"], function (_exports, _object, _route, _service, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/routing/route",0,"@ember/service",0,"ember-concurrency"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let EditRoute = (_class = class EditRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "settings", _descriptor4, this);
    }

    model() {
      return this.modelFor('groups.group');
    }

    setupController(controller, model) {
      controller.setProperties({
        group: model,
        handleSubmit: this.handleSubmit,
        handleClose: this.handleClose,
        addDataUrl: this.addDataUrl
      });
    }

    addDataUrl(group, dataUrl) {
      group.set('uploadingDataUrl', dataUrl);
    }

    *handleClose(group) {
      yield this.settings.confirmClose(group.hasDirtyAttributes);
      group.rollbackAttributes();
      this.router.transitionTo('account.groups.group');
    }

    *handleSubmit(group) {
      try {
        const {
          alert
        } = yield this.settings.submitForm.perform(group.save(), 'account.groups.group.edit');
        this.alerts.add(alert);
        this.handleClose.perform(group);
      } catch ({
        alert
      }) {
        this.alerts.add(alert);
        group.rollbackAttributes();
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addDataUrl", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addDataUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSubmit", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmit"), _class.prototype)), _class);
  _exports.default = EditRoute;
});